/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class TenantApi {
    static getInstance() {
        if (!this.instance) this.instance = new TenantApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取租户列表
    async getTenantList (param,page_num, page_size){
        let url = `/api/sys/tenant/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存租户
    async saveTenant (param){
        let url = `/api/sys/tenant/save/all`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 更新租户
    async updateTenant (param){
        let url = `/api/sys/tenant/update/all`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 获取详情
    async getTenantDetail (id){
        let url = `/api/sys/tenant/all/info/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 故障码新增编辑-上传图片
    async uploadPictures (param){
        let url = `/api/sys/pictures/upload`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }
}

export {
    TenantApi
}